module["exports"] = [
  "Esc. ###",
  "Puerta ###",
  "Edificio #"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/es_MX/address/secondary_address.js
// module id = 758
// module chunks = 0